import { createContext, FC, ReactNode, useContext, useMemo } from "react";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { AzureSSOSettingsInput } from "../components/loginWithAzureSSO/types/ssoConfiguration";
import { useGetAzureSSOSettings } from "../components/loginWithAzureSSO/hooks/useGetAzureSSOSettings";
export const SSOContext = createContext<{
  ssoData: AzureSSOSettingsInput | null | undefined;
  getSsoDataLoading: boolean;
  msalConfig: PublicClientApplication | null | undefined;
}>({
  ssoData: undefined,
  getSsoDataLoading: false,
  msalConfig: undefined,
});

export interface MsalSSOProviderProps {
  children: ReactNode;
}

export const MsalSSOProvider: FC<MsalSSOProviderProps> = ({ children }) => {
  const { ssoData, getSsoDataLoading } = useGetAzureSSOSettings();

  const msalInstance = useMemo(() => {
    if (ssoData) {
      return new PublicClientApplication({
        auth: {
          clientId: ssoData.clientId,
          authority: ssoData.authority,
          redirectUri: ssoData.redirectUri,
        },
      });
    } else {
      return undefined;
    }
  }, [ssoData]);

  return (
    <SSOContext.Provider
      value={{ ssoData, getSsoDataLoading, msalConfig: msalInstance }}
    >
      {msalInstance ? (
        <MsalProvider instance={msalInstance}>{children}</MsalProvider>
      ) : (
        children
      )}
    </SSOContext.Provider>
  );
};
// eslint-disable-next-line react-refresh/only-export-components
export const useSSOContext = () => useContext(SSOContext);
